import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * Combina classes resolvendo conflitos do Tailwind.
 *
 * `twMerge` garante que a classe passada por prop vença a do componente
 * (`px-4` de fora sobrescreve `px-3` de dentro), em vez de as duas coexistirem
 * e a ordem do CSS decidir.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
